import { createCallableRouteInvoker } from '../../../../../shared/backend/transports/callable';
import { firebase } from '@/lib/firebaseConfig';

export const invokeCallableRoute = createCallableRouteInvoker(
  firebase.functions,
);
